import React from "react";
import {
    Badge, Button
} from 'reactstrap';
//Icons
import EditIcon from 'react-icons/lib/md/edit';
import CheckIcon from 'react-icons/lib/md/check';
import ClearIcon from 'react-icons/lib/md/clear';
import ToolTipItem from "../utils/tooltip";
import ServerPaginatedTable from "../utils/pagination.server";
import DownloadIcon from "react-icons/lib/md/cloud-download";

const FlightTableStructure = ({data, editCallback,handleAirlinesDownload}) => (
    <div>
    <div className="d-flex justify-content-start mb-3">
    <Button
      className="btn btn-avi-secondary"
      onClick={handleAirlinesDownload}
    >
      <DownloadIcon /> Download
    </Button>
  </div>
    <table className="table table-striped table-hover">
        <thead>
        <tr>
            <th>Airline</th>
            <th>Flight Number</th>
            <th>Departure</th>
            <th>Destination</th>
            <th>Flight Type</th>
            <th>Flight Days</th>
            <th>Active</th>
            <th>Action</th>
        </tr>
        </thead>
        <tbody>
        {data.map((item, i) =>
            <tr key={i}>
            <td className='text-capitalize'>
                {item.Airline && item.Airline.Name}
                </td>
            <td>{item.FlightNumber}</td>
            <td>
                {item.DepartureAirport &&
                    item.DepartureAirport.Name}
                </td>
            <td>
                {item.DestinationAirport && item.DestinationAirport.Name}
                 </td>
            <td>
                {item.IsLocal &&
                    <Badge color='warning'>&nbsp;Local&nbsp;</Badge>
                }
                {!item.IsLocal &&
                    <Badge color='success'>&nbsp;&nbsp;International&nbsp;&nbsp;</Badge>
                }
            </td>
            <td style={{"width" : "13%"}}>
                { item.FlightDaysNames && item.FlightDaysNames.join(', ') }
             </td>
            <td>
                {item.Active &&
                    <CheckIcon color="#43a8df"/>
                }
                {!item.Active &&
                    <ClearIcon color="#43a8df"/>
                }
            </td>
            <td>
                <span className="text-primary pointer" onClick={(e) => editCallback(item)}>
                   <ToolTipItem key={i + 'edit'} title={<EditIcon size="15" color="#43a8df"/>} content='Edit record' id={i + 'edit'}/>
                </span>
            </td>
        </tr>)}
        </tbody>
    </table>
    </div>
);
class FlightTable extends React.Component {
    render() {
        let { data, editCallback, pageSize, currentPage, totalFlightCounts, pageDataCallback, handleAirlinesDownload } = this.props;
         return (
            <div>
                <ServerPaginatedTable currentPage={currentPage} fetchMore={pageDataCallback} target={<FlightTableStructure editCallback={editCallback} data={data} handleAirlinesDownload={handleAirlinesDownload}/>} pageSize={pageSize} totalCount={ totalFlightCounts } />
            </div>
        )
    }
}
export default FlightTable;



// WEBPACK FOOTER //
// ./src/views/flight/flight.table.js